<template>
  <div class="navBox">
      <div class="name">
          <i class="icon icon-logo"></i>
          <p class="">珍时题库管理发布系统</p>
      </div>
      <div class="navList">
        <div class="navItem" v-for="item in navList" v-bind:key="item.id">
          <div class="item" :class="navID==item.id?'select':''" @click="navSub(item)">
            <i class="icon" :class="'icon'+item.id"></i>
            <p>{{item.label}}</p>
          </div>
          <div class="children" v-if="item.showType">
            <div class="item" v-for="ele in item.children" v-bind:key="ele.id" :class="ele.id==childrenID?'select':''" @click='childrenSub(ele)'>
              <p>{{ele.label}}</p>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
  export default {
      name: 'navBox',
      data() {
        return {
          navList: [
            {
              id:1,
              label: '证书管理',
              children: [{
                id:'1-1',
                label: '证书类型设置',
                url:'/certificate'
              },{
                id:'1-2',
                label: '证书列表',
                url:'/list'
              }]
            }, 
            // {
            //   id:2,
            //   label: '题目管理',
            //   children: [{
            //     id:'2-1',
            //     label: '题目管理',
            //     url:'/topic'
            //   }]
            // },
            {
              id:3,
              label: '学员管理',
              url:'/student'
            },
            // {
            //   id:4,
            //   label: '统计模块',
            //   url:'/statistics'
            // },
            {
              id:6,
              label: '课程管理',
              url:'/course'
            },
            {
              id:5,
              label: '系统管理',
              children: [{
                id:'5-1',
                label: '后台帐号管理',
                url:'/admin'
              },{
                id:'5-2',
                label: '角色管理',
                url:'/user'
              },{
                id:'5-3',
                label: '账户信息',
                url:'/account'
              },
              // {
              //   id:'5-4',
              //   label: '开通机构和账号',
              //   url:'/open'
              // },
              {
                id:'5-5',
                label: '题型配置',
                url:'/config'
              }]
            },
          ],
          navID:'',
          childrenID:'',
          userData:'',
          url:''
        };
      },
      props: {
        title: String,
        visible: {
          type: Boolean,
          default: false
        },
        id: String,
        cid: String,
      },
      mounted() {
        this.getUser();
        var that = this;
        this.navID = this.id;
        this.childrenID = this.cid;
        var list = this.navList;
        list.forEach(function(item,index){
          if(that.navID == item.id&&!item.children){
            document.title = item.label
          };
          if(item.children){
            item.children.forEach(function(ele,num){
              if(ele.id == that.childrenID){
                item.showType = true;
                document.title = ele.label;
              }
            })
          };
        });
        this.$forceUpdate();
        var url = '';
        if(window.location.origin == 'https://orgp.zens10.com'){
          url = 'https://apps.zens10.com/'
        } else if(window.location.origin == 'https://org.zens10.com'){
          url = 'https://app.zens10.com/'
        } else {
          url = 'https://lite.zens10.com/'
        };
        this.url = url;
      },
      methods: {
        navSub(e){
          var that = this;
          if(e.children){
            e.showType = !e.showType;
            this.childrenID = e.id;
          };
          this.navID = e.id;
          this.$forceUpdate();
          if(e.url){
            this.$router.push(e.url);
          }
        },

        childrenSub(e){
          if(e.url){
            this.$router.push(e.url);
          }
        },

        getUser(){
          var that = this;
          var data = localStorage.getItem('userdata');
          this.userData = JSON.parse(data);
          if(data == null){
            this.$message('请先登录！');
            this.$router.push('/');
          }
          if(this.userData.level == 0){
            that.navList = [
              {
                id:5,
                label: '系统管理',
                children: [{
                  id:'5-4',
                  label: '开通机构和账号',
                  url:'/open'
                }]
              }
            ]
          } else {
          };
          if(this.userData.type == 2){//模拟卷
            that.navList = [
              {
                id:1,
                label: '考试管理',
                children: [{
                  id:'1-1',
                  label: '考试类型管理',
                  url:'/exam'
                },{
                  id:'1-2',
                  label: '考试列表',
                  url:'/examList'
                }]
              }, 
              {
                id:3,
                label: '学员管理',
                url:'/parent'
              },
              {
                id:6,
                label: '老师管理',
                url:'/teacher'
              },
              {
                id:8,
                label: '成绩管理',
                url:'/score'
              },
              {
                id:5,
                label: '系统管理',
                children: [{
                  id:'5-1',
                  label: '后台帐号管理',
                  url:'/admin'
                },{
                  id:'5-2',
                  label: '角色管理',
                  url:'/power'
                },{
                  id:'5-3',
                  label: '账户信息',
                  url:'/account'
                }]
              },
              {
                id:4,
                label: '会员管理',
                url:'/vipList'
              },
              {
                id:7,
                label: '营销管理',
                children: [{
                  id:'7-1',
                  label: 'banner',
                  url:'/market'
                },
                {
                  id:'7-2',
                  label: '意见反馈',
                  url:'/feedback'
                }
              ]
              },
            ]
          }
        }
      }
  }
</script>
<style scoped>
  .navBox .name .icon-logo{
    background-image: url(~@/assets/images/logo.png);
    width: 36px;
    height: 43px;
    background-size: 36px 43px;
    display: inline-block;
    vertical-align: top;
  }
  
  .navBox .navList .navItem i.icon1{
    background-image: url(~@/assets/images/nav-icon1.png);
  }
  .navBox .navList .navItem .select .icon1{
    background-image: url(~@/assets/images/nav-icon1-1.png);
  }

  .navBox .navList .navItem i.icon2{
    background-image: url(~@/assets/images/nav-icon2.png);
  }

  .navBox .navList .navItem .select .icon2{
    background-image: url(~@/assets/images/nav-icon2-1.png);
  }

  .navBox .navList .navItem i.icon3{
    background-image: url(~@/assets/images/nav-icon3.png);
  }

  .navBox .navList .navItem .select .icon3{
    background-image: url(~@/assets/images/nav-icon3-1.png);
  }

  .navBox .navList .navItem i.icon4{
    background-image: url(~@/assets/images/nav-icon4.png);
  }

  .navBox .navList .navItem .select .icon4{
    background-image: url(~@/assets/images/nav-icon4-1.png);
  }

  .navBox .navList .navItem i.icon5{
    background-image: url(~@/assets/images/nav-icon5.png);
  }

  .navBox .navList .navItem .select .icon5{
    background-image: url(~@/assets/images/nav-icon5-1.png);
  }
</style>


// WEBPACK FOOTER //
// src/components/comment/nav.vue